module.exports = __webpack_public_path__ + "static/media/15.55c21f76.jpg";